import { inject } from '@angular/core';
import {
  CanActivateFn,
  Route,
  Router,
  UrlMatchResult,
  UrlSegment,
} from '@angular/router';

import { RESERVED_ROUTE_SEGMENTS } from '../../shared/routing/role-routing.util';
import { TenantService } from '../services/tenant.service';

/** Matches legacy `/{tenantSlug}/...` URLs so they can be redirected to `/...`. */
export function legacyTenantPrefixMatcher(
  segments: UrlSegment[],
): UrlMatchResult | null {
  if (segments.length < 2) {
    return null;
  }

  const slug = segments[0].path.toLowerCase();
  if (!slug || RESERVED_ROUTE_SEGMENTS.has(slug)) {
    return null;
  }

  return {
    consumed: [segments[0]],
    posParams: { tenantSlug: segments[0] },
  };
}

/** Strips the legacy tenant prefix (e.g. `/acme/admin/...` → `/admin/...`). */
export const stripTenantPrefixGuard: CanActivateFn = (route, state) => {
  const tenantService = inject(TenantService);
  const router = inject(Router);
  const slug = route.paramMap.get('tenantSlug')?.toLowerCase() ?? '';

  if (!tenantService.isAllowedSlug(slug)) {
    return router.parseUrl('/auth/login');
  }

  const [path, query = ''] = state.url.split('?');
  const stripped = path.replace(new RegExp(`^/${slug}(?=/|$)`), '') || '/';
  const target = query ? `${stripped}?${query}` : stripped;

  return router.parseUrl(target);
};

/** Placeholder child so Angular activates the legacy matcher route. */
export const legacyTenantRedirectRoutes: Route[] = [
  { path: '**', children: [] },
];
